import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'CLIENT_FAV',
  title: 'Wie setze ich ein Lesezeichen für meinen Kunden?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Gehen Sie auf die Registerkarte "Kunden“'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CLIENT_FAV/DE_CLIENT_FAV_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Wählen Sie den Kund Ihrer Wahl'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Klicken Sie auf den Stern in der oberen rechten Ecke, um es zu den Favoriten hinzuzufügen oder zu entfernen.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CLIENT_FAV/DE_CLIENT_FAV_2.png`
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_CLIENT_FAV/DE_CLIENT_FAV_3.png`
  }]
};
